var exports = {};
// IE8- don't enum bug keys
exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
export default exports;